/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputAdminChatChannel
 */
export interface OutputAdminChatChannel {
    /**
     * 
     * @type {number}
     * @memberof OutputAdminChatChannel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminChatChannel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminChatChannel
     */
    type: string;
    /**
     * 
     * @type {OutputZoneShort}
     * @memberof OutputAdminChatChannel
     */
    zone?: OutputZoneShort;
}

/**
 * Check if a given object implements the OutputAdminChatChannel interface.
 */
export function instanceOfOutputAdminChatChannel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function OutputAdminChatChannelFromJSON(json: any): OutputAdminChatChannel {
    return OutputAdminChatChannelFromJSONTyped(json, false);
}

export function OutputAdminChatChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminChatChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': json['type'],
        'zone': json['zone'] == null ? undefined : OutputZoneShortFromJSON(json['zone']),
    };
}

export function OutputAdminChatChannelToJSON(value?: OutputAdminChatChannel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'zone': OutputZoneShortToJSON(value['zone']),
    };
}

